export enum WalletAwardFormMode {
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum AwardTypeEnum {
  PROMO_CODE = 'promo_code',
  OTHERS = 'other',
}

export enum RedemptionRefundSettingEnum {
  NO_REFUND = 'no_refund',
  PARTIAL_REFUND = 'partial_refund',
  FULL_REFUND = 'full_refund',
}

export enum EnrolmentType {
  BY_SEGMENT = 'SEGMENTS',
  SPECIFIC = 'AGENTS',
}

export enum AwardStatusEnum {
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  COMPLETED = 'completed',
  SUSPEND = 'suspend',
  PENDING = 'pending',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
}

export type WalletAwardListParam = {
  pageSize: number;
  page: number;
  awardId?: string;
  awardNameZh?: string;
  awardNameEn?: string;
  redemptionStartDate?: Date;
  redemptionEndDate?: Date;
  awardAvailabilityStartDate?: Date;
  awardAvailabilityEndDate?: Date;
  status?: string;
};

export type WalletAwardListItem = {
  requireRedemption: boolean;
  awardId: string;
  awardNameEn?: string;
  awardNameZh?: string;
  awardType?: string;
  awardValidityStartDate?: Date;
  awardValidityEndDate?: Date;
  remainingQuantity?: string;
  status?: string;
};

export type WalletAwardPaginateList = {
  items: WalletAwardListItem[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  totalPages?: number;
};

export type WalletAwardListRes = {
  success: boolean;
  data: WalletAwardPaginateList;
};

type WalletUpdateAwardStatusResult = {
  awardId: string;
  status: string;
};
export type WalletUpdateAwardStatusRes = {
  success: boolean;
  data: WalletUpdateAwardStatusResult;
};
// Submit award for approval
export type AwardSubmitAwardForApproval = {
  submittedBy: string;
};

// Approval award
export type ApproveAward = {
  approvedBy: string;
};

// Reject award
export type RejectAward = {
  rejectedBy: string;
  reason?: string;
};

// Cancel award
export type CancelAwardD = {
  cancelledBy: string;
  reason?: string;
};

// Cancel award
export type CompleteAward = {
  completedBy: string;
};

// Cancel award
export type PausedAward = {
  pausedBy: string;
};

export type UPDATE_AWARD_STATUS =
  | AwardSubmitAwardForApproval
  | ApproveAward
  | RejectAward
  | CancelAwardD
  | CompleteAward
  | PausedAward;

export enum AWARD_STATUS_OPERATION {
  SUBMIT_TO_APPROVE = 'submit',
  APPROVE = 'approve',
  REJECT = 'reject',
  CANCEL = 'cancel',
  COMPLETE = 'complete',
  ACTIVE = 'activate',
  // TODO：Use deactivate as temporary replacement for pause. PRUWALLET-125 will switch this to use pause
  PAUSE = 'deactivate',
}
